import React from "react";

const CalendarIcon = () => {
    return (
        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="calendar_today">
                <mask id="mask0_493_24187" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="25">
                    <rect id="Bounding box" y="0.5" width="24" height="24" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_493_24187)">
                    <path id="calendar_today_2" d="M6.55556 20.5C6.12778 20.5 5.76157 20.3433 5.45694 20.03C5.15231 19.7167 5 19.34 5 18.9V7.7C5 7.26 5.15231 6.88333 5.45694 6.57C5.76157 6.25667 6.12778 6.1 6.55556 6.1H7.33333V4.5H8.88889V6.1H15.1111V4.5H16.6667V6.1H17.4444C17.8722 6.1 18.2384 6.25667 18.5431 6.57C18.8477 6.88333 19 7.26 19 7.7V18.9C19 19.34 18.8477 19.7167 18.5431 20.03C18.2384 20.3433 17.8722 20.5 17.4444 20.5H6.55556ZM6.55556 18.9H17.4444V10.9H6.55556V18.9ZM6.55556 9.3H17.4444V7.7H6.55556V9.3Z" fill="#1C1B1F" />
                </g>
            </g>
        </svg>
    );
};

export default CalendarIcon;
